import { useLocalStorage } from '@vueuse/core';

type Settings = {
  layout: {
    expandedAssets?: boolean;
    expandedNews?: boolean;
    expandedSymbolChart?: boolean;
  };
  releaseNote: {
    lastSeenReleaseNoteVersion?: string;
  };
};

const DEFAULT_SETTINGS: Settings = {
  layout: {},
  releaseNote: {},
};

export default function useUserSettings() {
  const settings = useLocalStorage<Settings>('settings', DEFAULT_SETTINGS, {
    mergeDefaults: false,
  });

  const updateLayoutSettings = (
    key: keyof Settings['layout'],
    value: boolean
  ) => {
    settings.value.layout[key] = value;
  };

  const updateReleaseNoteSettings = (
    key: keyof Settings['releaseNote'],
    value: string
  ) => {
    settings.value.releaseNote[key] = value;
  };

  return {
    settings,
    updateLayoutSettings,
    updateReleaseNoteSettings,
  };
}
